import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = ["name", "id", "placeholder", "required", "rows"];
const _hoisted_3 = ["type", "name", "id", "placeholder", "required"];
import { computed } from "vue";
import FormControl from "./FormControl.vue";
import resettableValue from "../../tools/resettable_value";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormInput',
    props: /*@__PURE__*/ _mergeModels({
        label: String,
        placeholder: String,
        error: String,
        name: { type: String, required: true },
        required: Boolean,
        type: { type: String, default: 'text' },
        rows: Number,
    }, {
        "modelValue": { type: String, default: '' },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, "modelValue");
        const id = computed(() => `form-control_${props.name}`);
        const errorMessage = resettableValue(() => props.error, value);
        const classes = computed(() => ({
            'form-field--text': !['textarea', 'select'].includes(props.type),
            'form-field--textarea': props.type === 'textarea',
            'form-field--select': props.type === 'select',
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormControl, {
                required: __props.required,
                error: _unref(errorMessage)
            }, {
                default: _withCtx(() => [
                    (__props.label)
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 0,
                            for: id.value,
                            class: "form-label"
                        }, _toDisplayString(__props.label), 9 /* TEXT, PROPS */, _hoisted_1))
                        : _createCommentVNode("v-if", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-field form-field--1 form-field--m form-field--primary", classes.value])
                    }, [
                        _renderSlot(_ctx.$slots, "default", {}, () => [
                            (__props.type === 'textarea')
                                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 0,
                                    name: __props.name,
                                    class: "form-control",
                                    id: id.value,
                                    placeholder: __props.placeholder,
                                    required: __props.required,
                                    rows: __props.rows,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                                }, null, 8 /* PROPS */, _hoisted_2)), [
                                    [_vModelText, value.value]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: __props.type,
                                    name: __props.name,
                                    class: "form-control",
                                    id: id.value,
                                    placeholder: __props.placeholder,
                                    required: __props.required,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((value).value = $event))
                                }, null, 8 /* PROPS */, _hoisted_3)), [
                                    [_vModelDynamic, value.value]
                                ])
                        ])
                    ], 2 /* CLASS */),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "extra")
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["required", "error"]));
        };
    }
});
